import axios from '../request'

// 创建OTC交易订单
export const createOtcOrder = (data) => {
  return axios({
    url: `/otc/trade/create`,
    method: 'post',
    data
  })
}

// 查询OTC交易订单
export const queryOtcOrder = (orderNo) => {
  return axios({
    url: `/otc/trade/query`,
    method: 'get',
    params: { orderNo }
  })
}

// 查询商户OTC订单列表
export const tradePage = (data) => {
  return axios({
    url: `/otc/trade/page`,
    method: 'POST',
    data: data
  })
}

// 查询执行记录
export const queryExecution = (id) => {
  return axios({
    url: `/otc/execution/query`,
    method: 'get',
    params: { id }
  })
}

// 分页查询执行记录
export const queryExecutionPage = (data) => {
  return axios({
    url: `/otc/execution/page`,
    method: 'POST',
    data: data
  })
}
